import { CHECK_ROLE_ERROR, CHECK_ROLE_SUCCESS, CHECK_ROLE_POST_ERROR } from "../actions/types";

export default (state = {  
    error: null,
    userRoles: [], 
    success: null,
}, action) => {
    switch (action.type) {
        case CHECK_ROLE_ERROR:
            return {
                ...state,
                error:  action.payload,
                success: action.payload.status,
            };
            break;
        case CHECK_ROLE_SUCCESS:
            return {
                ...state,
                error: null,
                userRoles: action.payload,
                success: true,
            };
            break;
        case CHECK_ROLE_POST_ERROR:
            return {
                ...state,
                error: state.error,
                success: action.payload,
            };
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/checkUserReducer.js